import axios from 'axios';

export default axios.create({
    //baseURL: 'http://localhost:5000', 
    //baseURL: 'https://sistema-de-notas-de-servico-api.onrender.com'
    baseURL: process.env.REACT_APP_API
});